<template>
  <div style="width: 1200px; margin: 0 auto; padding-top: 20px;">
    <div class="index_nav_div">
      <div class="bg_div">
        <!---------面包屑导航---------->
        <table cellpadding="0" cellspacing="0" style="border-width: 0; padding: 0px" border="0">
          <tbody>
            <tr style="border-width: 0" border="0">
              <th style="border-width: 0; padding: 0px" border="0">&nbsp;</th>
              <td style="border-width: 0; padding: 0px" border="0" class="td_y">
                当前所在位置：
                <template v-for="(item, index) in breadCrumb">
                  <RouterLink :to="index == 0 ? '/' : '/detail?' + item.path">{{
                    item.name
                  }}</RouterLink><span>&nbsp;》&nbsp;</span>
                </template>{{ title }}
              </td>
              <td style="border-width: 0; padding: 0px" border="0" class="td_bg">
                &nbsp;
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="news clearfix">
      <div class="cont">
        <div class="mbox_data">
          <div class="top_title">
            {{ title }}
            <span style="font-size: 13px; color: #aaa; margin-left: 8px">
              {{ createTime }}
            </span>
          </div>
          <div class="top_date">
            <div class="text">字体:</div>
            <el-input-number v-model="currentFontSize" :min="12" :max="24" @change="handleChange" />
          </div>
          <div style="
              clear: both;
              margin-bottom: 12px;
              border-bottom: 1px dashed #ccc;
            "></div>
          <div class="ql-container ql-snow ql-editor" style="border: 0px solid #ccc">
            <div id="content_data" class="ql-editor" v-html="content" style="padding-top: 12px; line-height: 150%">
            </div>
          </div>
          <div class="close_div">
            <a href="javascript:window.close();" target="_self">
              <img src="@/assets/images/btn_close.jpg" style="border: 0" /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getArticleInfo } from "@/api/home";
import { ref } from "vue";
import { useRoute } from "vue-router";
const route = useRoute();
let title = ref("");
let createTime = ref("");
let breadCrumb = ref([]);
let content = ref("");

const currentFontSize = ref(16);

function handleChange(size) {
  console.log("currentFontSize.value", size);
  const editor = document.querySelector(".ql-editor");
  editor.style.fontSize = size + "px";
}

function getArticleDetail() {
  const id = route.params.id;
  console.log("id", id);
  getArticleInfo(id).then((res) => {
    title.value = res.data.title;
    createTime.value = res.data.createTime;
    content.value = res.data.content;

    res.data.menuVO.forEach((item) => {
      breadCrumb.value.push({
        name: item.menuName,
        path: item.menuUrl,
      });
      if (item.menuVOS !== null) {
        item.menuVOS.forEach((inItem) => {
          breadCrumb.value.push({
            name: inItem.menuName,
            path: inItem.menuUrl,
          });
        });
      }
    });

    const menuUrl = res.data?.menuVO[1]?.menuVOS[0]?.menuUrl || "aa";
    sessionStorage.setItem("articleParams", JSON.stringify(menuUrl));
  });
}

getArticleDetail();
</script>
<style scoped lang="scss">
.cont {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
}

.mbox_data {
  width: 100%;
}

.mbox_data .top_title {
  width: 100%;
  height: 35px;
  text-align: center;
  font: 15px/50px "SimSun", sans-serif;
  font-weight: bold;
  color: #0a83ee;
}

.mbox_data .top_date {
  width: 100%;
  height: 20px;

  padding-bottom: 8px;
  display: flex;
  width: 180px;
  float: right;

  :deep(.el-input-number) {
    width: 120px;
  }

  .text {
    line-height: 20px;
  }
}

.mbox_data .top_date span {
  text-align: right;
  font: 12px/20px "SimSun", sans-serif;
  font-weight: normal;
  color: #999;
  display: block;
  width: 150px;
  float: right;
  margin-right: 5px;
}

.mbox_data .data {
  width: 95%;
  font: 13px/30px "SimSun", sans-serif;
  margin: 20px auto;
}

.mbox_data .data p {
  text-indent: 2em;
  font: 13px/30px "SimSun", sans-serif;
}

.close_div {
  width: 100%;
  text-align: center;
}
</style>
